import React from 'react';
import BlogCard from './BlogCard';
import { blogPosts } from '../../data/blogData';
import './BlogSection.css';

function BlogSection() {
  return (
    <section className="blog-section-wrapper py-5">
      <div className="container">
        <div className="row g-4">
          {blogPosts.map((post) => (
            <BlogCard key={post.id} {...post} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default BlogSection;
